export default "__VITE_ASSET__CIaQKeKm__"